import { months } from  '@/interfaces/dates';
import { IDateRange } from  '@/interfaces/insightsp2';

import moment from 'moment';

function today():IDateRange {

    const dateFrom = moment().hour(0).toDate();
    const dateTo = moment().hour(0).toDate();
    const label = "Today";

    return {dateFrom, dateTo, label}
}

function yesterday():IDateRange {

    const dateFrom = moment().subtract(1,'d').hour(0).toDate();
    const dateTo = moment().subtract(1,'d').hour(0).toDate();
    const label = "Yesterday";

    return {dateFrom, dateTo, label}
}

function removeTimeZone(date:Date):string {

    // Set time to zero
    const dateZero  = removeTime(date);

    // Remove timezone
    return new Date(dateZero.getTime() - (dateZero.getTimezoneOffset() * 60000)).toISOString();
}

function buildCustomDate(date:Date):string{

    const moDate = moment(date);

    return `${moDate.date()}/${moDate.month() + 1}/${moDate.format('YY')}`;
}

function removeTime(date:Date):Date{

    const removed = moment(date).set("hours", 0).set("minute", 0).set("seconds", 0);

    return removed.toDate();

}

function endOfDayTime(date:Date):Date{

    const removed = moment(date).set("hours", 23).set("minute", 59).set("seconds", 59);

    return removed.toDate();

}

function ordinal(number) {
    switch (number) {
      case 1:
      case 21:
        return number + 'st';
      case 2:
      case 22:
        return number + 'nd';
      case 3:
      case 23:
        return number + 'rd';
      default:
        return number + 'th';
    }
}

function dateToUTC(date:Date){

  const now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

  return new Date(now_utc);
}

function datesSame(d1:Date, d2:Date){

  if (d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()){
    return true
  }

  return false
}

function padZeros(val:number){

  if (val < 10){
    return '0' + val.toString()
  }

  return val
}

function getDateRange(dateRangeSelected:string): IDateRange {

  if (!dateRangeSelected){
      return
  }

  let dateFrom;
  let dateTo;

  switch(dateRangeSelected) {

    case "today":

        dateFrom = moment().hour(12).toDate();
        dateTo = moment().hour(12).toDate();
        break;

    case "yesterday":

        dateFrom = moment().subtract(1,'d').hour(12).toDate();
        dateTo = moment().subtract(1,'d').hour(12).toDate();
        break;

    case "lastweek":

        dateFrom = moment().subtract(1,'w').startOf('week').add('day').hour(12).toDate();
        dateTo = moment().subtract(1,'w').endOf('week').hour(12).toDate();
        break;

    case "last7days":

        dateFrom = moment().subtract(7,'d').hour(12).toDate();
        dateTo = moment().hour(12).toDate();
        break;
  
    case "lastmonth":

        dateFrom = moment().subtract(1,'month').startOf('month').hour(12).toDate();
        dateTo = moment().subtract(1,'month').endOf('month').hour(12).toDate();
        break;
  
    case "last3months":
        dateFrom = moment().subtract(3,'month').startOf('month').hour(12).toDate();
        dateTo = moment().subtract(1,'month').endOf('month').hour(12).toDate();
        break;

    case "last6months":
      
        dateFrom = moment().subtract(6,'month').startOf('month').hour(12).toDate();
        dateTo = moment().subtract(1,'month').endOf('month').hour(12).toDate();
        break;

    case "lastyear":
    
        dateFrom = moment().subtract(12,'month').startOf('month').hour(12).toDate();
        dateTo = moment().subtract(1,'month').endOf('month').hour(12).toDate();
        break;

    default:
  }

  return { dateFrom, dateTo };
}

function formatDateToNearestHour(date: Date) {
  date.setHours(date.getHours() + 1);
  const options: Intl.DateTimeFormatOptions = { hour: "numeric",  hourCycle:'h23'};
  return new Intl.DateTimeFormat(undefined, options).format(date);
};

function formatDateStringToTime(dateString: string) {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "numeric",
    hourCycle:'h23'
  };
  return new Intl.DateTimeFormat(undefined, options).format(date);
};

function formatDateStringWithDateTimeOffset(dateString: string) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const second = String(date.getSeconds()).padStart(2, '0');
  const millisecond = String(date.getMilliseconds()).padStart(3, '0');
  const timeZoneOffset = date.getTimezoneOffset();
  const timeZoneOffsetHours = Math.floor(Math.abs(timeZoneOffset) / 60).toString().padStart(2, '0');
  const timeZoneOffsetMinutes = (Math.abs(timeZoneOffset) % 60).toString().padStart(2, '0');
  const timeZoneSign = timeZoneOffset <= 0 ? '+' : '-';

  return `${year}-${month}-${day}T${hour}:${minute}:${second}.${millisecond}${timeZoneSign}${timeZoneOffsetHours}:${timeZoneOffsetMinutes}`;
}

function formatDateWithOffset(date: Date) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  const offsetMinutes = date.getTimezoneOffset();
  const offsetHours = Math.abs(Math.floor(offsetMinutes / 60)).toString().padStart(2, '0');
  const offsetSign = offsetMinutes < 0 ? '+' : '-';
  const timezoneOffset = `${offsetSign}${offsetHours}:${Math.abs(offsetMinutes % 60).toString().padStart(2, '0')}`;

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneOffset}`;
  return formattedDate;
}

function getStartAndEndDate(filterDates: Date[]): string[] {
    // if no dates
    if (filterDates.length === 0) {
        return ['', '']
    }
    else if (filterDates.length === 1) {
        const st = filterDates[0]
        const et = filterDates[0]
        st.setHours(0,0,1)
        const stTemp = st.toISOString();
        et.setHours(23,59,59)
        return [stTemp, et.toISOString()]
    }
    else {
        const st = filterDates[0]
        const et = filterDates[1]
        st.setHours(0,0,1)
        et.setHours(23,59,59)
        return [st.toISOString(), et.toISOString()]
    }
    // if only 1 date
}

function formatDateToIfModifiedFormat(date: Date) {
  let options = {
    weekday: "short",
    year: "numeric",
    month: "short",
    timeZoneName: "short",
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: "Etc/Greenwich",
    hour12: false
  };
  const dateParts = new Intl.DateTimeFormat("en-GB", options as Intl.DateTimeFormatOptions).formatToParts(date);

  const requiredDateValues = ['weekday', 'day', 'month', 'year', 'hour', 'minute', 'second' ]

  let dateMap: any = {}
  
  for (const dateKey of requiredDateValues) {
    dateMap[dateKey] = dateParts.find((val) => val.type === dateKey)
  } 



  return `${dateMap.weekday.value}, ${dateMap.day.value} ${dateMap.month.value} ${dateMap.year.value} ${dateMap.hour.value}:${dateMap.minute.value}:${dateMap.second.value} GMT`
}

function getTimeAtStartOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0); 
}

export function getOrdinalSuffix(day: number): string {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
  }
};

export interface Itime {value: number, label: string}

export function formatDateToDDMMYYYYHHMM(isoString: string): string {
  const date = new Date(isoString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function formatDateToMMHHDDReadableMonthYYYY(isoString: string): string {
  const date = new Date(isoString);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${hours}:${minutes} ${day} ${month} ${year}`;
}

export {formatDateWithOffset, getDateRange, today, yesterday, removeTimeZone, buildCustomDate, removeTime, endOfDayTime, ordinal, dateToUTC, datesSame, padZeros, formatDateToNearestHour, formatDateStringToTime, formatDateStringWithDateTimeOffset, getStartAndEndDate, formatDateToIfModifiedFormat, getTimeAtStartOfDay}


export const getTwoDaysAgoFormatted = (): string => {
  const date = new Date();

  // Subtract 2 days
  date.setDate(date.getDate() - 2);

  // Helper to pad numbers
  const pad = (num: number) => String(num).padStart(2, "0");

  const day = pad(date.getUTCDate());
  const month = pad(date.getUTCMonth() + 1);
  const year = date.getUTCFullYear();

  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());

  // Format timezone as +00:00
  const timezone = "+00:00";

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${timezone}`;
};

export function getTodaysDate(): string {
  const now = new Date();

  const pad = (num: number) => num.toString().padStart(2, '0');

  const day = pad(now.getUTCDate());
  const month = pad(now.getUTCMonth() + 1);
  const year = now.getUTCFullYear();

  const hours = pad(now.getUTCHours());
  const minutes = pad(now.getUTCMinutes());
  const seconds = pad(now.getUTCSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} +00:00`;
}